import { Injectable } from '@angular/core';
import { LoginService } from './login.service';
import { MsalService } from '@azure/msal-angular';
import { CatalogsService } from './catalogs.service';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  token: any;

  constructor(
    private router: Router,
    private msalService: MsalService,
    private loginService: LoginService,
    private requestsService: CatalogsService) { }

  canActivate(): boolean {
    this.token = String(localStorage.getItem('token1'))
    if (this.msalService.instance.getAllAccounts().length > 0) {
      this.requestsService.getAllArea(this.token)
        .subscribe(
          (res) => {
            console.log('Token Valido');
          },(err) => {
            if(err.statusText === 'Unauthorized'){
              localStorage.clear();
              this.loginService.Authenticated();
              localStorage.removeItem('token1');
              this.router.navigate(['/login']);
            }
          }
        )
      return true; // El usuario está autenticado
    } else {
      this.router.navigate(['/login']); // Redirigir al usuario al login si no está autenticado
      return false;
    }
  }

}
